import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCheck = (props, ref) => (React.createElement("svg", { width: 16, height: 16, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M383-251.5q-8.957 0-17.533-3.478t-16.293-11.196l-169-169Q166.5-448.848 167-469.5t14.174-34.326 34.065-13.674 34.065 13.674L385-368.131l326.696-326.695q13.674-13.674 33.326-13.794 19.652-.119 33.565 13.794 13.674 13.674 13.674 33.446t-13.674 33.445L416.826-266.174q-7.717 7.718-16.293 11.196T383-251.5" })));
const ForwardRef = forwardRef(SvgCheck);
const Memo = memo(ForwardRef);
export default Memo;
